/* NGC motion: scroll reveal + pinned-section progress.
   No dependencies. Reveal is IntersectionObserver + CSS (opacity/transform only).
   Pinned sections get a --ngc-progress (0..1) variable, updated in one
   passive, rAF-throttled scroll listener only while the section is near the viewport. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Reveal ---------- */
  var revealIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealIO.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-ngc-reveal]').forEach(function (el) {
      if (el.hasAttribute('data-ngc-ready')) return;
      el.setAttribute('data-ngc-ready', '');

      var i = 0;
      el.querySelectorAll('.ngc-r').forEach(function (child) {
        child.style.setProperty('--i', i++);
      });

      if (el.hasAttribute('data-ngc-load')) return; /* CSS-only, nothing to observe */
      if (!revealIO || reduce.matches) {
        el.classList.add('is-in');
        return;
      }
      revealIO.observe(el);
    });
  }

  /* ---------- Pinned progress ---------- */
  var pins = [];
  var ticking = false;

  var pinIO = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.__ngcActive = entry.isIntersecting;
        });
        schedule();
      }, { rootMargin: '25% 0px 25% 0px' })
    : null;

  function initPins(root) {
    if (reduce.matches) return;
    root.querySelectorAll('[data-ngc-pin]').forEach(function (el) {
      if (el.__ngcPin) return;
      el.__ngcPin = true;
      pins.push(el);
      if (pinIO) pinIO.observe(el);
      else el.__ngcActive = true;
    });
    schedule();
  }

  function update() {
    ticking = false;
    pins = pins.filter(function (el) { return el.isConnected; });
    var vh = window.innerHeight;
    pins.forEach(function (el) {
      if (!el.__ngcActive) return;
      var track = el.querySelector('.ngc-section__track');
      if (!track) return;
      var rect = track.getBoundingClientRect();
      var total = rect.height - vh;
      if (total <= 0) return;
      var p = Math.min(1, Math.max(0, -rect.top / total));
      el.style.setProperty('--ngc-progress', p.toFixed(4));
    });
  }

  function schedule() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  /* ---------- Header height -> --ngc-header-total ---------- */
  var headerRO = null;

  function bindHeader() {
    var header = document.querySelector('.shopify-section-group-header-group');
    if (!header) return;
    function measure() {
      var h = Math.round(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--ngc-header-total', h + 'px');
    }
    measure();
    if ('ResizeObserver' in window) {
      if (headerRO) headerRO.disconnect();
      headerRO = new ResizeObserver(measure);
      headerRO.observe(header);
    } else {
      window.addEventListener('resize', measure, { passive: true });
    }
  }

  bindHeader();

  /* ---------- Boot + theme editor support ---------- */
  function boot(root) {
    initReveal(root);
    initPins(root);
  }

  boot(document);

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
    bindHeader();
  });
})();
